import { styled, Typography as MuiTypography } from '@mui/material';

export const Typography = styled(MuiTypography)(() => ({
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const FileWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  padding: '12px',
  gap: '12px',
  backgroundColor: theme.palette.background.default,
  maxWidth: '680px',
  maxHeight: '360px',
  overflow: 'auto',
  minWidth: '240px',
  '& > *': {
    flex: '0 0 180px',
    width: '180px',
    maxWidth: '180px',
  },
}));
